import { Col, Row } from "@commonlibs";
import styled, { css } from "styled-components";

export const SetConversionRateTabRoot = styled(Col)(
    ({ theme }) => css`
        gap: ${theme.spacing[4]};
    `,
);

export const InfoBox = styled(Row)(
    () => css`
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;
        padding: 16px;
    `,
);

export const TableContainer = styled(Col)(
    () => css`
        background: white;
    `,
);

export const TableHeader = styled(Row)(
    () => css`
        background: white;
        border-bottom: 2px solid #dee2e6;
        padding: 12px 16px;
    `,
);

export const TableRow = styled(Row)(
    () => css`
        background: white;
        padding: 12px 16px;
        align-items: center;
        border-bottom: 2px solid #dee2e6;
    `,
);

export const TableCell = styled(Col)(
    () => css`
        flex: 1;
        display: flex;
        align-items: center;

        &:last-child {
            flex: 2;
        }
    `,
);

export const EditableCell = styled(Row)(
    () => css`
        align-items: center;
        gap: 8px;
        width: 100%;
    `,
);

export const EditableInput = styled.div(
    () => css`
        flex: 1;

        .MuiTextField-root {
            .MuiOutlinedInput-root {
                border: 1px solid #e9ecef;
                background: white;
                box-shadow: none;
                border-radius: 4px;
                min-height: 32px;

                &:hover {
                    border-color: #adb5bd;
                }

                &:focus-within {
                    border-color: #6f42c1;
                    box-shadow: 0 0 0 2px rgba(111, 66, 193, 0.2);
                }

                &.Mui-disabled {
                    background: #f8f9fa;
                    cursor: default;

                    &:hover {
                        border-color: #e9ecef;
                    }
                }
            }

            .MuiInputBase-input {
                padding: 6px 8px;
                font-size: 14px;
                color: #495057;

                &.Mui-disabled {
                    color: #6c757d;
                    cursor: default;
                }
            }
        }
    `,
);

export const EditIconButton = styled.button(
    () => css`
        background: none;
        border: none;
        padding: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000000;

        &:hover {
            color: #333333;
        }

        &:focus {
            outline: none;
        }

        svg {
            width: 20px;
            height: 20px;
        }
    `,
);
